import React, { useCallback } from 'react';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { rem } from 'design-system/values';
import Choices from 'design-system/Choices';
import StatusBar from 'design-system/StatusBar';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { AppView, withAnimatedNavigationHeader } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { KYCDocumentType } from '../types';
import { useCommonInvestStyles } from './styles';
import { useAmplitudeOnMountEvent } from '../utils/analytics';
const choices = [
    'Passport',
    'UK or EEA Driving Licence',
    'National EEA Identity Card',
    'UK Biometric Residence Permit',
];
const SelectDocumentScreen = withAnimatedNavigationHeader(({ route, navigation: { navigateDeprecated }, scrollHandler }) => {
    const flow = route.params?.flow;
    const styles = useStyles(styleSet);
    const commonStyles = useCommonInvestStyles();
    useAmplitudeOnMountEvent(flow, 'User Upload POI Screen');
    const onSelect = useCallback((choice) => {
        switch (choice) {
            case 'Passport':
                navigateDeprecated('WealthPOIUploadInstructionsScreen', { flow, documentType: KYCDocumentType.PASSPORT });
                break;
            case 'UK or EEA Driving Licence':
                navigateDeprecated('WealthPOIUploadInstructionsScreen', {
                    flow,
                    documentType: KYCDocumentType.DRIVING_LICENCE,
                });
                break;
            case 'National EEA Identity Card':
                navigateDeprecated('WealthPOIUploadInstructionsScreen', {
                    flow,
                    documentType: KYCDocumentType.NATIONAL_ID,
                });
                break;
            case 'UK Biometric Residence Permit':
                navigateDeprecated('WealthPOIUploadInstructionsScreen', {
                    flow,
                    documentType: KYCDocumentType.UK_BIOMETRIC_RESIDENCE_PERMIT,
                });
                break;
            default:
                break;
        }
    }, [flow]);
    return (<AppView withFrame={false}>
        <StatusBar barStyle="dark-content" animated/>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} contentContainerStyle={commonStyles.contentContainerWithBottomSafeArea}>
          <ScreenInfoHeader smallSubTitle title="Choose a document" preTitle="Proof of identity" subTitle="Select one of the following:"/>
          <View style={styles.paddingHorizontal}>
            <Choices data={choices} onSelect={onSelect}/>
          </View>
        </Animated.ScrollView>
      </AppView>);
}, ({ colors }) => ({
    hideTitleOnScroll: true,
    title: 'Choose a document',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styleSet = createStyleSheets(() => ({
    paddingHorizontal: {
        paddingHorizontal: rem(16),
    },
}));
export default SelectDocumentScreen;
